(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const closer = event.target.closest('[data-drawer-close], .header__drawer-overlay');
    if (closer) {
      const drawer = closer.closest('details.header__drawer');
      if (drawer) drawer.removeAttribute('open');
    }
  });

  class HeaderSearch extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-hs-toggle]');
      this.panel = this.querySelector('[data-hs-panel]');
      this.input = this.querySelector('[data-predictive-input]');
      if (!this.toggle || !this.panel) return;
      this.onDoc = (e) => { if (!this.contains(e.target)) this.close(); };
      this.onKey = (e) => { if (e.key === 'Escape') this.close(); };
      this.toggle.addEventListener('click', () => {
        this.classList.contains('is-open') ? this.close() : this.open();
      });
      this.querySelectorAll('[data-hs-close]').forEach((b) =>
        b.addEventListener('click', () => this.close())
      );
    }
    open() {
      this.classList.add('is-open');
      this.panel.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this.onDoc);
      document.addEventListener('keydown', this.onKey);
      if (this.input) setTimeout(() => this.input.focus(), 30);
    }
    close() {
      this.classList.remove('is-open');
      this.panel.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this.onDoc);
      document.removeEventListener('keydown', this.onKey);
    }
  }
  if (!customElements.get('header-search')) customElements.define('header-search', HeaderSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('.main-collection__sidebar-details').forEach((details) => {
    const wide = window.matchMedia('(min-width: 990px)');
    const drawer = window.matchMedia('(max-width: 749px)');
    const sync = () => {
      if (wide.matches) {
        details.open = true;
        details.setAttribute('data-desktop-open', '');
      } else {
        details.removeAttribute('data-desktop-open');
        // In the mobile filter drawer the facets always show (no inner collapse).
        if (drawer.matches) details.open = true;
      }
    };
    sync();
    wide.addEventListener('change', sync);
    drawer.addEventListener('change', sync);
    if (window.location.search.includes('filter.')) details.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.featured = this.querySelector('[data-gallery-featured] img');
      this.thumbs = this.querySelectorAll('[data-gallery-thumb]');
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.swap(thumb));
      });
      // Swap the featured image when a variant with its own image is selected.
      this._onVariant = (e) => this.showMedia(e.detail);
      document.addEventListener('variant:media-change', this._onVariant);
    }
    disconnectedCallback() {
      document.removeEventListener('variant:media-change', this._onVariant);
    }
    swap(thumb) {
      const full = thumb.dataset.full;
      if (this.featured && full) {
        this.featured.src = full;
        this.featured.removeAttribute('srcset');
      }
      this.thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
    }
    showMedia(detail) {
      if (!detail || !this.featured) return;
      const id = String(detail.mediaId || '');
      const thumb = [...this.thumbs].find((t) => t.dataset.mediaId === id);
      if (thumb) {
        this.swap(thumb);
      } else if (detail.src) {
        this.featured.src = detail.src;
        this.featured.removeAttribute('srcset');
      }
    }
  }
  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-slabs"]) return;
  try {
    
  class SlabFilterBar extends HTMLElement {
    connectedCallback() {
      this.details = Array.from(this.querySelectorAll('details[data-filter]'));
      this.onToggle = this.onToggle.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.details.forEach((d) => d.addEventListener('toggle', this.onToggle));
      document.addEventListener('click', this.onDocClick);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
    }
    onToggle(event) {
      if (!event.target.open) return;
      this.details.forEach((d) => { if (d !== event.target) d.open = false; });
    }
    onDocClick(event) {
      if (this.contains(event.target)) return;
      this.details.forEach((d) => { d.open = false; });
    }
  }
  if (!customElements.get('slab-filter-bar')) customElements.define('slab-filter-bar', SlabFilterBar);

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-predictive-input]');
      this.panel = this.querySelector('[data-predictive-results]');
      this.url = this.dataset.url;
      this.searchUrl = this.dataset.searchUrl;
      this.view = this.dataset.view;
      if (!this.input || !this.panel || !this.url) return;
      this.options = [];
      this.active = -1;
      this.timer = null;
      this.controller = null;
      this.cache = new Map();
      this.money = this.moneyFormatter();
      this.onInput = this.onInput.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('keydown', this.onKeydown);
      this.input.addEventListener('focus', () => {
        if (this.options.length && this.input.value.trim().length >= 2) this.open();
      });
      document.addEventListener('click', this.onDocClick);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
    }
    moneyFormatter() {
      const currency = this.dataset.currency || 'USD';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency });
      } catch (e) {
        return { format: (n) => currency + ' ' + Number(n).toFixed(2) };
      }
    }
    onInput() {
      const q = this.input.value.trim();
      clearTimeout(this.timer);
      if (q.length < 2) { this.clear(); this.close(); return; }
      this.timer = setTimeout(() => this.fetch(q), 200);
    }
    async fetch(q) {
      if (this.cache.has(q)) { this.render(q, this.cache.get(q)); return; }
      const url = this.url + '.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product&resources[limit]=8'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,product_type,variants.title,vendor,tag,body';
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      try {
        const res = await fetch(url, { signal: this.controller.signal });
        if (!res.ok) return;
        const data = await res.json();
        const products = (((data.resources || {}).results || {}).products) || [];
        this.cache.set(q, products);
        if (this.input.value.trim() === q) this.render(q, products);
      } catch (e) { /* aborted or network error - keep prior results */ }
    }
    thumb(product) {
      const raw = (product.featured_image && product.featured_image.url) || product.image;
      if (!raw) return null;
      try { const u = new URL(raw, window.location.origin); u.searchParams.set('width', '120'); return u.href; }
      catch (e) { return raw; }
    }
    viewAllLink(q) {
      const all = document.createElement('a');
      all.className = 'pquick__all';
      all.tabIndex = -1;
      all.href = this.searchUrl + '?q=' + encodeURIComponent(q) + (this.view ? '&view=' + encodeURIComponent(this.view) : '');
      all.textContent = (this.dataset.viewAll || 'View all results for %TERMS%').replace('%TERMS%', q);
      return all;
    }
    render(q, products) {
      this.clear();
      if (!products.length) {
        const empty = document.createElement('p');
        empty.className = 'pquick__empty';
        empty.textContent = (this.dataset.noResults || 'No matches for %TERMS%').replace('%TERMS%', q);
        this.panel.appendChild(empty);
        // Predictive search has weaker typo tolerance than the full results page,
        // so always offer a way through to the full search (which finds typos).
        this.panel.appendChild(this.viewAllLink(q));
        this.options = [];
        this.open();
        return;
      }
      const id = this.input.getAttribute('aria-controls');
      products.forEach((p, i) => {
        const row = document.createElement('a');
        row.className = 'pquick__link';
        row.setAttribute('role', 'option');
        row.id = id + '-opt-' + i;
        row.setAttribute('aria-selected', 'false');
        row.href = p.url;
        row.tabIndex = -1;

        const thumb = document.createElement('span');
        thumb.className = 'pquick__thumb';
        const src = this.thumb(p);
        if (src) {
          const img = document.createElement('img');
          img.src = src; img.alt = ''; img.loading = 'lazy';
          thumb.appendChild(img);
        }
        row.appendChild(thumb);

        const text = document.createElement('span');
        text.className = 'pquick__text';
        const name = document.createElement('span');
        name.className = 'pquick__name';
        name.textContent = p.title;
        text.appendChild(name);
        const metaParts = [p.vendor, p.type].filter(Boolean);
        if (metaParts.length) {
          const meta = document.createElement('span');
          meta.className = 'pquick__meta';
          meta.textContent = metaParts.join(' · ');
          text.appendChild(meta);
        }
        row.appendChild(text);

        const price = document.createElement('span');
        price.className = 'pquick__price';
        price.textContent = this.money.format(parseFloat(p.price));
        row.appendChild(price);

        this.panel.appendChild(row);
      });

      this.panel.appendChild(this.viewAllLink(q));

      this.options = Array.from(this.panel.querySelectorAll('[role="option"]'));
      this.active = -1;
      this.open();
    }
    clear() {
      this.panel.innerHTML = '';
      this.options = [];
      this.active = -1;
    }
    open() {
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }
    close() {
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.setActive(-1);
    }
    setActive(index) {
      this.options.forEach((o, i) => o.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      this.active = index;
      const opt = this.options[index];
      if (opt) {
        this.input.setAttribute('aria-activedescendant', opt.id);
        opt.scrollIntoView({ block: 'nearest' });
      } else {
        this.input.removeAttribute('aria-activedescendant');
      }
    }
    onKeydown(event) {
      if (this.panel.hidden || !this.options.length) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.setActive((this.active + 1) % this.options.length);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.setActive((this.active - 1 + this.options.length) % this.options.length);
      } else if (event.key === 'Enter') {
        const opt = this.options[this.active];
        if (opt) { event.preventDefault(); window.location.href = opt.href; }
      } else if (event.key === 'Escape') {
        this.close();
      }
    }
    onDocClick(event) {
      if (!this.contains(event.target)) this.close();
    }
  }
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-pricing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('membership-pricing')) {
    customElements.define(
      'membership-pricing',
      class MembershipPricing extends HTMLElement {
        connectedCallback() {
          this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
          this.onChange = this.onChange.bind(this);
          this.radios.forEach((radio) => radio.addEventListener('change', this.onChange));
          const checked = this.radios.find((radio) => radio.checked);
          this.apply(checked ? checked.value : this.dataset.defaultPeriod || 'monthly');
        }

        disconnectedCallback() {
          this.radios.forEach((radio) => radio.removeEventListener('change', this.onChange));
        }

        onChange(event) {
          this.apply(event.target.value);
        }

        apply(period) {
          const annual = period === 'annual';
          this.querySelectorAll('[data-price]').forEach((el) => {
            const value = annual ? el.dataset.priceAnnual : el.dataset.priceMonthly;
            if (value != null) el.textContent = value;
          });
          this.querySelectorAll('[data-suffix]').forEach((el) => {
            el.textContent = (annual ? el.dataset.suffixAnnual : el.dataset.suffixMonthly) || '';
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  if (!customElements.get('newsletter-popup')) {
    customElements.define(
      'newsletter-popup',
      class NewsletterPopup extends HTMLElement {
        connectedCallback() {
          this.STORE = 'cph_news_popup';
          this.PENDING = 'cph_news_popup_pending';
          this.SESSION = 'cph_news_popup_session';
          this.dialog = this.querySelector('.npopup__dialog');
          this.form = this.querySelector('.npopup__form');

          this.querySelectorAll('[data-np-close]').forEach((el) =>
            el.addEventListener('click', () => this.close(true))
          );
          this._onKey = (e) => { if (e.key === 'Escape') this.close(true); };

          if (this.form) {
            this.form.addEventListener('submit', () => {
              try { localStorage.setItem(this.PENDING, '1'); } catch (e) {}
            });
          }

          this.decide();
        }

        read() {
          try { return JSON.parse(localStorage.getItem(this.STORE)) || {}; }
          catch (e) { return {}; }
        }
        write(obj) {
          try { localStorage.setItem(this.STORE, JSON.stringify(obj)); } catch (e) {}
        }
        sessionState() {
          try { return JSON.parse(sessionStorage.getItem(this.SESSION)) || { n: 0, t: 0 }; }
          catch (e) { return { n: 0, t: 0 }; }
        }
        saveSession(s) {
          try { sessionStorage.setItem(this.SESSION, JSON.stringify(s)); } catch (e) {}
        }

        decide() {
          if (window.Shopify && window.Shopify.designMode) return;
          if (document.querySelector('.coming-soon')) return;

          const store = this.read();
          if (store.subscribed) return;

          const posted = this.dataset.posted === 'true';
          let pending = false;
          try { pending = localStorage.getItem(this.PENDING) === '1'; } catch (e) {}

          if (posted) {
            this.write({ subscribed: true });
            try { localStorage.removeItem(this.PENDING); } catch (e) {}
            if (pending) this.open();
            return;
          }

          if (pending) {
            try { localStorage.removeItem(this.PENDING); } catch (e) {}
            this.open();
            return;
          }

          if (this.dataset.showMobile === 'false' && window.matchMedia('(max-width: 749px)').matches) return;

          const maxShows = Math.max(1, parseInt(this.dataset.max, 10) || 3);
          const gapMs = Math.max(0, parseInt(this.dataset.gap, 10) || 3) * 60000;
          const sess = this.sessionState();
          if (sess.n >= maxShows) return;

          const settle = Math.max(0, parseInt(this.dataset.delay, 10) || 0) * 1000;
          if (sess.t) {
            if (Date.now() - sess.t < gapMs) return;
          }
          this._timer = setTimeout(() => this.open(), settle);
        }

        open() {
          const sess = this.sessionState();
          sess.n = (sess.n || 0) + 1;
          sess.t = Date.now();
          this.saveSession(sess);
          this.classList.add('is-open');
          document.documentElement.style.overflow = 'hidden';
          document.addEventListener('keydown', this._onKey);
          const input = this.querySelector('.npopup__input');
          if (input) setTimeout(() => input.focus(), 60);
        }

        close(record) {
          this.classList.remove('is-open');
          document.documentElement.style.overflow = '';
          document.removeEventListener('keydown', this._onKey);
          if (this._timer) clearTimeout(this._timer);
          if (record) {
            const sess = this.sessionState();
            sess.t = Date.now();
            this.saveSession(sess);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  class ResourceList extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.resource-list__track');
      this.prev = this.querySelector('.resource-list__arrow--prev');
      this.next = this.querySelector('.resource-list__arrow--next');
      if (!this.track || !this.prev || !this.next) return;
      this.prev.addEventListener('click', () => this.page(-1));
      this.next.addEventListener('click', () => this.page(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.page(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.page(1); }
      });
      this.update();
    }
    page(dir) {
      this.track.scrollBy({ left: dir * this.track.clientWidth, behavior: 'smooth' });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      this.prev.disabled = this.track.scrollLeft <= 0;
      this.next.disabled = this.track.scrollLeft >= max;
    }
  }
  if (!customElements.get('resource-list')) customElements.define('resource-list', ResourceList);

  } catch(e) { console.error(e); }
})();
})();
